import React, { useState, useEffect } from 'react';
import { TextField, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from '../../services/api';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';

const PatientSelect = ({ value, onChange, endpoint }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    if (!endpoint) return;
    setLoading(true);
    const debounce = setTimeout(async () => {
      try {
        const { data } = await api.get(endpoint, {
          params: { searchParam: search },
        });
        setOptions(data.patients || []);
      } catch (err) {
        console.error("Error cargando pacientes", err);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 500);
    return () => clearTimeout(debounce);
  }, [search, endpoint]);
  
  return (
    <Autocomplete
      options={options}
      loading={loading}
      value={selectedValue}
      noOptionsText="No hay opciones"
      loadingText="Cargando..."
      onChange={(event, newValue) => {
        setSelectedValue(newValue);
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setSearch(newInputValue);
      }}
      getOptionLabel={(option) => {
        const contactName = option.contact.name;
        const patientName = option.patientName;

        if (patientName && patientName !== contactName) {
          return `${patientName} (Contacto: ${contactName})`;
        }
        return contactName;
      }}
      renderOption={(option) => {
        const dateObj = parse(option.lastAppointmentDate, 'yyyy-MM-dd', new Date());
        const formattedDate = format(dateObj, 'd MMM yyyy', { locale: es });
        const formattedTime = option.lastAppointmentStartTime.substring(0, 5);

        let primaryText;
        if (option.patientName && option.patientName !== option.contact.name) {
          primaryText = `${option.patientName} (Contacto: ${option.contact.name})`;
        } else {
          primaryText = option.contact.name;
        }

        return (
          <div>
            <div>{primaryText}</div>
            <div style={{ fontSize: '0.8em', color: 'gray' }}>
              Última cita: {formattedDate} a las {formattedTime}
            </div>
          </div>
        );
      }}
      isOptionEqualToValue={(option, value) => option.contact.id === value.contact.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Buscar paciente por nombre o contacto"
          variant="outlined"
          margin="dense"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default PatientSelect;